import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';

import { useSessionContext } from '@/auth/useSessionContext';
import { ACCOUNT_OPENING_ENABLED } from '@/consts/accountOpening';
import { COMPANY_STATUS_LABELS } from '@/consts/financial';
import useBaasAccount from '@/hooks/useBaasAccount';
import useCompanyData from '@/hooks/useCompanyData';
import { PATH_DASHBOARD } from '@/routes/paths';

const isTruthyFlag = (value) => value === true || value === 'true' || value === 1 || value === '1';

const ACCOUNT_BLOCKED_KEYS = [
  'accountBlocked',
  'account_blocked',
  'isAccountBlocked',
  'is_account_blocked',
  'isAccountBlockedWithoutDigitalAccount',
  'is_account_blocked_without_digital_account',
  'isBlockedWithoutDigitalAccount',
  'blockedWithoutDigitalAccount',
  'blocked_without_digital_account',
];

export default function DigitalAccountOpeningGuard() {
  const { user } = useSessionContext();
  const { companyData, isLoadingCompany } = useCompanyData();
  const { accountResolutionStatus, isLoadingAccount, accountUpdatedAt } = useBaasAccount();
  const isResolvingCompany = isLoadingCompany && !companyData;
  const isResolvingAccount =
    accountResolutionStatus === 'loading' ||
    (accountResolutionStatus === undefined && isLoadingAccount && !accountUpdatedAt);

  // Antes do spinner: com a abertura desligada não há o que resolver, e esperar
  // company/account só atrasaria o redirect.
  if (!ACCOUNT_OPENING_ENABLED) {
    return <Navigate to={PATH_DASHBOARD.general.financial} replace />;
  }

  if (isResolvingCompany || isResolvingAccount) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  const companyContext = { ...companyData, ...user };
  const effectiveCompanyStatus =
    companyData?.status || user?.companyStatus || user?.company?.status || user?.status;
  const isAccountBlocked = ACCOUNT_BLOCKED_KEYS.some((key) =>
    isTruthyFlag(companyContext[key])
  );

  if (effectiveCompanyStatus === COMPANY_STATUS_LABELS.BLOCKED || isAccountBlocked) {
    return <Navigate to={PATH_DASHBOARD.general.financial} replace />;
  }

  return <Outlet />;
}
